// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lc-0";